import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@admin-core/services/auth.service';
import { TranslationKey } from '@admin-core/i18n/translations/en';
import { TranslatePipe } from '@admin-core/i18n/translate.pipe';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent {
  readonly cards = computed(() => {
    const items: { titleKey: TranslationKey; descKey: TranslationKey; path: string }[] = [
      {
        titleKey: 'dashboard.orders.title',
        descKey: 'dashboard.orders.desc',
        path: '/admin/orders'
      },
      {
        titleKey: 'dashboard.products.title',
        descKey: 'dashboard.products.desc',
        path: '/admin/products'
      },
      {
        titleKey: 'dashboard.bundles.title',
        descKey: 'dashboard.bundles.desc',
        path: '/admin/bundles'
      },
      {
        titleKey: 'dashboard.brands.title',
        descKey: 'dashboard.brands.desc',
        path: '/admin/brands'
      },
      {
        titleKey: 'dashboard.categories.title',
        descKey: 'dashboard.categories.desc',
        path: '/admin/categories'
      },
      {
        titleKey: 'dashboard.filters.title',
        descKey: 'dashboard.filters.desc',
        path: '/admin/category-filters'
      },
      {
        titleKey: 'dashboard.specs.title',
        descKey: 'dashboard.specs.desc',
        path: '/admin/category-specs'
      }
    ];

    if (this.auth.canManageUsers()) {
      items.unshift({
        titleKey: 'dashboard.users.title',
        descKey: 'dashboard.users.desc',
        path: '/admin/users'
      });
    }

    if (this.auth.canManageModules()) {
      items.unshift({
        titleKey: 'dashboard.settings.title',
        descKey: 'dashboard.settings.desc',
        path: '/admin/settings'
      });
    }

    return items;
  });

  constructor(private readonly auth: AuthService) {}
}
